import styled from 'styled-components';
import { rem } from 'polished';
import { H6 } from '~typography';
var LoaderMessage = styled(H6).withConfig({
  displayName: "LoaderMessage",
  componentId: "sc-1wgcxg9-0"
})(["padding-top:", ";"], rem(8));
export default LoaderMessage;